import { render, staticRenderFns } from "./AppCorreo.vue?vue&type=template&id=10140a96&scoped=true"
import script from "./AppCorreo.vue?vue&type=script&lang=js"
export * from "./AppCorreo.vue?vue&type=script&lang=js"
import style0 from "./AppCorreo.vue?vue&type=style&index=0&id=10140a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10140a96",
  null
  
)

export default component.exports